// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"V0-z","refreshPageWarning":"W0-z","redirectMessageText":"X0-z"};